export const ACTOR_ROUTES = {
  events: {
    index: {
      route: '/events',
      tabs: {
        projects: {
          route: 'projects'
        },
        castings: {
          route: 'castings',
          tabs: {
            active: { route: 'active' },
            my_responses: { route: 'my-responses' }
          }
        }
      }
    },
    companies: {
      index: '/events/companies',
      /**
       * Перейти на страницу проектов и кастингов компании
       * @param id - id компании
       */
      show: (id: string) => `/events/companies/${id}`
    },
    projects: {
      /**
       * Перейти на страницу проекта
       * @param id - id проекта
       */
      show: (id: number) => `/events/projects/${id}`
    },
    castings: {
      /**
       * Перейти на страницу кастинга
       * @param projectId - id проекта
       * @param castingId - id кастинга
       */
      show: (projectId: number, castingId: number) =>
        `/events/projects/${projectId}/castings/${castingId}`
    }
  },
  profile: {
    index: {
      route: '/profile',
      tabs: {
        main: { route: 'main' },
        appearance: { route: 'appearance' },
        experience: { route: 'experience' },
        gallery: {
          route: 'gallery',
          tabs: { photo: { route: 'photo' }, video: { route: 'video' } }
        }
      }
    },
    preview: {
      route: '/profile/preview/:id',
      /**
       * Предпросмотр своего профиля глазами кинокомпании
       * @param id - id текущего пользователя
       */
      show: (id: number) => `/profile/preview/${id}`,
      tabs: {
        profile: { route: 'profile' },
        gallery: { route: 'gallery' }
      }
    },
    choose_excerpt: {
      index: '/profile/choose-excerpt',
      record_video_reading: {
        index: '/profile/choose-excerpt/record-video-reading',
        prompter_settings:
          '/profile/choose-excerpt/record-video-reading/prompter-settings'
      }
    }
  },
  responses: {
    index: '/responses'
  },
  actor_cards: {
    index: '/actor-registry'
  }
} as const;
